import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { HomepageCMS } from "@/components/admin/HomepageCMS";

export const Route = createFileRoute("/admin/homepage")({
  component: HomepagePage,
  head: () => ({
    meta: [
      { title: "Homepage CMS — Admin" },
      { name: "description", content: "Manage home page section headings and copy" },
    ],
  }),
});

function HomepagePage() {
  return (
    <AdminLayout>
      <HomepageCMS />
    </AdminLayout>
  );
}
